import config from "../environments/generated.config"

export const toCurrency = (value) =>
  value?.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
    maximumFractionDigits: 8,
  })

const renderOptions = (item, key) => ({
  lente: `https://repositorio.lenteshaytek.com.br/${item.PRODUTO}.jpg`,
  darker: !(key % 2 === 0),
  single: false,
  itemID: key,
})

const infoOptions = (item) => ({
  OS: item.OSHTK,
  OSCLI: item.OSCLI,
  nome: item.NOME,
  opticsName: item.NOMOTI,
  mounting: Boolean(item.MONTAGEM),
  coloring: Boolean(item.COLORACAO),
  produto: item.PRODUTO,
  primary: item.CARAC_PRINCIPAL,
  secondary: item.CARAC_SEGUNDARIA,
  tertiary: item.CARAC_TERCIARIA,
  quaternary: item.CARAC_QUARTENARIA,
  quintenary: item.CARAC_QUINTENARIA,
  description: item.CARAC_TERCIARIA,
})

const priceOptions = (item) => ({
  qty: item?.QUANTIDADE || 1,
  price: toCurrency(item.VLRLENTES),
  total: toCurrency(item.VALOR),
  service: toCurrency(item.VLRSERVICO),
})

const lensOptions = (item) => ({
  montagem: item.MONTAGEM,
  DIR_ESFER: item.DIR_ESFER,
  ESQ_ESFER: item.ESQ_ESFER,
  DIR_EIXO: item.DIR_EIXO,
  ESQ_EIXO: item.ESQ_EIXO,
  DIR_CIL: item.DIR_CIL,
  ESQ_CIL: item.ESQ_CIL,
  DIR_ADD: item.DIR_ADD,
  ESQ_ADD: item.ESQ_ADD,
})

const baseModel = (item, key) => ({
  ...infoOptions(item),
  ...renderOptions(item, key),
})

const gradeModel = (order) =>
  order.map((item, key) => ({
    ...baseModel(item, key),
    ...{
      qty: item?.QUANTIDADE || 1,
      price: toCurrency(item.PRECO),
      total: toCurrency(item.VALORTOTAL),
    },
  }))

const paraparModel = (order) =>
  order.map((item, key) => ({
    ...baseModel(item, key),
    ...lensOptions(item),
    ...priceOptions(item),
  }))

const surfacadoModel = (order) =>
  order.map((item, key) => ({
    ...baseModel(item, key),
    ...lensOptions(item),
    ...priceOptions(item),
  }))

export const makeImageGlassModel = (model) => {
  const newModel = model.split(1, model.length)
  return `${config.urls.home}${config.urls.models_surfacado}/${newModel}.jpg`
}

export const makeOrder = (type, data) => {
  const types = {
    parapar: paraparModel(data.order),
    surfacado: surfacadoModel(data.order),
    grade: gradeModel(data.order, type),
  }

  return {
    type,
    orderId: data.orderId,
    qtyItens: data.total.QUANTIDADE,
    total: toCurrency(data.total.VALORTOTAL),
    itens: types[type],
  }
}

export const models = {
  "001": "01",
  "002": "02",
  "003": "03",
  "004": "04",
  "005": "05",
  "006": "06",
  "007": "07",
  "008": "08",
  "009": "09",
  "010": "10",
  "011": "11",
  "012": "12",
}

export const getDocumentHeight = function () {
  return Math.max(
    document.body.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.clientHeight,
    document.documentElement.scrollHeight,
    document.documentElement.offsetHeight
  )
}
